/**
 * Mobility Insights Utilities
 *
 * Risk level configurations and helper functions
 * for the Mobility Insights Results screen.
 */

import { getCurrentLocale } from "../../../../utlis/locale";

// Risk level configurations. `label` is the English source; render
// `labelKey` through the "riskInsights" i18n section.
export const RISK_LEVELS = {
  high: {
    key: "high",
    label: "High Risk of Fall",
    labelKey: "risk_high",
    status: "poor",
  },
  elevated: {
    key: "elevated",
    label: "Elevated Fall Risk",
    labelKey: "risk_elevated",
    status: "fair",
  },
  low: {
    key: "low",
    label: "Low Fall Risk",
    labelKey: "risk_low",
    status: "good",
  },
  processing: {
    key: "processing",
    label: "Processing...",
    labelKey: "risk_processing",
    status: "default",
  },
};

/**
 * Get risk level configuration
 */
export const getRiskLevelConfig = (riskLevel, isProcessing = false) => {
  if (isProcessing && !riskLevel) {
    return RISK_LEVELS.processing;
  }
  return RISK_LEVELS[riskLevel] || RISK_LEVELS.low;
};

/**
 * Format assessment date
 */
export const formatAssessmentDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString(getCurrentLocale(), {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};
